<template>
  <div style="display: flex;">
    <div class="col-lg-12 col-md-12 col-sm-12 padding-div-low">      
      <div>
        <h5>Jueces</h5>
        <hr />
        <table class="table table-striped table-light table-hover">
          <thead class="thead-dark">
            <tr>
              <th >Nombre</th>
              <th >Tipo</th>
            </tr>
          </thead>
          <tbody class="text-dark">
            <tr v-for="Juez in datos.Jueces">
              <td>{{Juez.Nombre}}</td>
              <td>{{Juez.Tipo.Nombre}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <br />
      <h5>Relaciones</h5>
      <hr />
      <table class="table table-striped table-light table-hover">
        <thead class="thead-dark">
          <tr>
            <th >Imputado</th>
            <th >Victima</th>
            <th >Delito</th>
          </tr>
        </thead>
        <tbody class="text-dark">
          <tr v-for="Relacion in datos.Relaciones">
            <td>{{Relacion.Imputado}}</td>
            <td>{{Relacion.Victima}}</td>
            <td>{{Relacion.Delito.Nombre}}</td>
          </tr>
        </tbody>
      </table>
      <div>
        <h5>Sesiones</h5>
        <hr />
        <div v-for="(Sesion, index) in datos.Sesiones">
          <h6>Sesión {{index + 1}}</h6>
          <hr/>
          <div style="display:flex">
            <div class="col-4">
              <p><strong>Sala: </strong><br />{{Sesion.Sala.Nombre}}</p>
            </div>
            <div class="col-4">
              <p><strong>Fecha de inicio: </strong><br />{{Sesion.FechaDeInicio}}</p>
            </div>
            <div class="col-4">
              <p><strong>Fecha de finalizacion: </strong><br />{{Sesion.FechaDeFinalizacion}}</p>
            </div>
          </div>
          <div class="col-12">
            <p><strong>Marcadores: </strong></p>
            <table class="table table-striped table-light table-hover">
              <thead class="thead-dark">
                <tr>
                  <th >Tiempo</th>
                  <th >Tipo</th>
                  <th >Comentarios</th>
                  <th >Evidencia</th>
                </tr>
              </thead>
              <tbody v-for="(Marcador, index) in Sesion.Marcadores" class="text-dark">
                <tr>
                  <td class="text-center">{{Marcador.Tiempo}}</td>
                  <td class="text-center">{{Marcador.TipoMarcador.Nombre}}</td>
                  <td class="text-center">{{Marcador.Comentarios}}</td>
                  <td class="text-center">
                    <i v-if="Marcador.Evidencias != undefined && Marcador.Evidencias.length > 0" class="fas fa-file-download" v-on:click="descargaEvidencia(Marcador.Evidencias)" title="Descargar evidencia"></i>
                    <i v-else class="fas fa-times" title="No hay evidencia"></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <br />
      <div>
        <h5>Permisos de acceso</h5>
        <hr />        
        <table class="table table-striped table-light table-hover">
          <thead class="thead-dark">
            <tr>              
              <th >Persona a entregar</th>
              <th >A quienes se entrego</th>
            </tr>
          </thead>
          <tbody class="text-dark">
            <tr v-if="datos.Permisos != undefined && datos.Permisos != undefined && datos.Permisos.length <= 0">
              <td colspan="5" class="text-center">No existen registros de personas</td>
            </tr>
            <tr v-else v-for="Permiso in datos.Permisos">              
              <td>{{Permiso.NombrePersonaAutorizada}}</td>
              <td>
                <span v-if="Permiso.PersonasQueRecogieronElToken.length <= 0">No ha sido entregado.</span>
                <span v-else v-for="(personaQueRecogioElToken, indice) in Permiso.PersonasQueRecogieronElToken" v-html="obtenPersonasALasQueSeLesEntregoFormato(indice, personaQueRecogioElToken)"></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- <br />
      <div>
        <h5>Permisos para ver en vivo</h5>
        <hr />
        <table class="table table-striped table-light table-hover">
          <thead class="thead-dark">
            <tr>
              <th class="text-center">Nombre(s)</th>
              <th class="text-center">Apellido Paterno</th>
              <th class="text-center">Apellido Materno</th>
            </tr>
          </thead>
          <tbody class="text-dark">
            <tr v-if="datos.PermisoParaVerEnVivo != undefined && datos.PermisoParaVerEnVivo.length <= 0">
              <td colspan="5" class="text-center">No existen registros</td>
            </tr>
            <tr v-else v-for="Permiso in datos.PermisoParaVerEnVivo">
              <td>{{Permiso.Usuario.Nombre}}</td>
              <td>{{Permiso.Usuario.ApellidoPaterno}}</td>
              <td>{{Permiso.Usuario.ApellidoMaterno}}</td>
            </tr>
          </tbody>
        </table>
      </div> -->
    </div>
  </div>
</template>

<script>
  //Importaciones estandarizadas
  import plantilla from '@/../static/js/plantillas'
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import catalogos from '@/../static/js/catalogos'
  import api from '@/../static/js/api'
  import axios from 'axios'

  export default {
    components: {
    },
    data() {
      return {
        comun,
        enumeraciones,
         Audiencia: Object,
        datos: {
          Jueces: [],
          Relaciones: [],
          Sesiones: [],
          Permisos: [],
          PermisoParaVerEnVivo: []
        }
      }
    },
    props: {
      AudienciaId: Number     
    },
    mounted() {      
      this.busquedaAudiencia();
    },
    methods: {
      descargaEvidencia(evidencias) {        
        evidencias.forEach((element) => {          
          if (element.Ruta == "") {
            comun.mensajeDeAlerta("La evidencia no tiene archivo", null, null);
          } else { debugger
  let t = api.Forseti.sistema.consultas.audienciasFinalizadas;
            location.href = api.conexion + api.Forseti.sistema.consultas.audienciasFinalizadas.DescargaEvidencia + "?ruta=" + element.Ruta;
          }
        })
      },
      async busquedaAudiencia() {
        comun.SeEstaCargandoInformacion(true);

        let _this = this;

        let peticion = {
          AudienciaId: this.AudienciaId,
          BaseDeDatosProvenienteId: this.BaseDeDatosProvenienteId
        }

        axios.post(api.conexion + api.Forseti.sistema.consultas.audienciasFinalizadas.GetAudienciaFinalizada,
          peticion,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
        ).then(async respuesta => {
          if (respuesta.data.SiHayError) {
            console.log(respuesta);
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
          } else {
            //CargarDatos de audiencia
            this.Audiencia = respuesta.data.AudienciaFinalizada;
            await this.cargaRelaciones();
            await this.cargaJueces();
            await this.cargaSesiones();
            await this.cargaPermisos();
            await this.cargaPermisosParaVerEnVivo();
          }
          comun.SeEstaCargandoInformacion(false);
        })
          .catch(e => {
            console.log("No Hay Respuesta del Servidor", e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
      },
      formatoNombrePersonalidad(value) {
        var Nombre = "";
        if (value != null && value != undefined) {
          switch (parseInt(value.TipoPersona.TipoPersonaId)) {
            case 1: //Autoridad
              Nombre = value.Autoridad.Institucion;
              break;
            case 2: //Física
              Nombre = (value.Fisica.Nombres == null || value.Fisica.Nombres == "" ? value.Fisica.Nombre : value.Fisica.Nombres) +
                (value.Fisica.ApellidoPaterno != "" && value.Fisica.ApellidoPaterno != null ? " " + value.Fisica.ApellidoPaterno : "") +
                (value.Fisica.ApellidoMaterno != "" && value.Fisica.ApellidoMaterno != null ? " " + value.Fisica.ApellidoMaterno : "");
              break;
            case 3: //Moral
              Nombre = value.Moral.Nombre;
              break;
            default:
              Nombre = "Sin Victima";
              break;
          }
        } else {
          if (value.ResulteResponsable)
            Nombre = "Sin Victima";
        }
        return Nombre;
      },
      obtenFechaDeEntregaConFormato: function(fechaDeEntrega) {
        return moment(fechaDeEntrega).format("DD-MM-YYYY [a las] h:mm a")
      },
       obtenPersonasALasQueSeLesEntregoFormato: function(indice, parametro) {
        return "" + (indice + 1) + ".- " + parametro.NombreCompleto + " presento su " + parametro.TipoIdentificacion.Nombre + " el día " + this.obtenFechaDeEntregaConFormato(parametro.FechaDeEntrega) + " " + this.crearLaDescargaDelArchivo(parametro.RutaDelArchivoDelToken) + "<br />";
      },
       crearLaDescargaDelArchivo: function(rutaDelArchivo){
        return '<a href="' + api.conexion + api.Comun.funcion.DescargarArchivo + '?rutaDelArchivo=' + rutaDelArchivo + '" target="_blank" title="Descarga el archivo del token."><i class="fas fa-file-download"></i></a>';
      },
      async cargaRelaciones() {
        let _this = this;
        this.datos.Relaciones = [];
        if (this.Audiencia.AudienciaId != null && this.Audiencia.AudienciaId > 0) {
          this.Audiencia.RelacionesDeLaAudiencia.forEach((element) => {
            _this.datos.Relaciones.push({
              Imputado: this.formatoNombrePersonalidad(element.Imputado.DatosGenerales),
              Victima: this.formatoNombrePersonalidad(element.Victima.DatosGenerales),
              Delito: element.Delito
            });
          });
        }
      },
      async cargaJueces() {
        let _this = this;
        this.datos.Jueces = [];
        if (this.Audiencia.AudienciaId != null && this.Audiencia.AudienciaId > 0) {
          this.Audiencia.JuecesEnAudiencia.forEach((element) => {
            _this.datos.Jueces.push({
              Nombre: this.formatoNombrePersonalidad({ TipoPersona: { TipoPersonaId: 2 }, Fisica: element.Juez }),
              Tipo: element.TipoJuez
            });
          });
        }
      },
      async cargaSesiones() {
        let _this = this;
        this.datos.Sesiones = [];
        if (this.Audiencia.AudienciaId != null && this.Audiencia.AudienciaId > 0) {
          this.Audiencia.SesionesDeLasAudiencias.forEach((element) => {
            _this.datos.Sesiones.push({
              SesionDeLaAudienciaId: element.SesionDeLaAudienciaId,
              Sala: element.Sala,
              PruebaRealizada: element.PruebaRealizada,
              FechaDeInicio: element.FechaDeInicio != null ? moment(element.FechaDeInicio).format('DD/MM/YYYY HH:mm:ss') : "SIN FECHA",
              FechaDeFinalizacion: element.FechaDeFinalizacion != null ? moment(element.FechaDeFinalizacion).format('DD/MM/YYYY HH:mm:ss') : "SIN FECHA",
              Marcadores: element.Marcadores
            });
          });
        }
      },
      async cargaPermisos() {
        let _this = this;
        this.datos.Permisos = [];
        if (this.Audiencia.AudienciaId != null && this.Audiencia.AudienciaId > 0) {
          this.Audiencia.PermisosDeLaAudiencia.forEach((element) => {
            _this.datos.Permisos.push({
              PermisoId: element.PermisoDeLaAudienciaId,
              FechaDeEntrega: element.FechaDeEntrega != null ? moment(element.FechaDeEntrega).format('DD/MM/YYYY HH:mm:ss') : "SIN FECHA",
              NombrePersonaAutorizada: element.NombreCompleto,
              NombrePersonaQueRecibe: element.NombreCompletoDeQuienLoRecibio,
              PersonasQueRecogieronElToken: element.PersonasQueRecogieronElToken,
              Entregado: element.Entregado,
              TipoIdentificacion: element.TipoIdentificacion != null ? element.TipoIdentificacion.Nombre : "N/A",
              Folio: element.FolioDeLaIdentificacion
            });
          });
        }
        console.log(this.datos.Permisos);
      },
      async cargaPermisosParaVerEnVivo() {
        let _this = this;
        this.datos.PermisoParaVerEnVivo = [];
        if (this.Audiencia.AudienciaId != null && this.Audiencia.AudienciaId > 0) {
          this.Audiencia.PermisoParaVerEnVivo.forEach((element) => {
            _this.datos.PermisoParaVerEnVivo.push({
              Usuario: element.Usuario
            });
          });
        }
      }
    }
  }
</script>

<style scoped>
  .padding-div-low {
    padding-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Forseti/Consultas/PanelDeAudienciasFinalizadas/_Detalles.vue